import { Student, MealGroupStudent } from '@/plugins/api'

/**
 * Resolve học sinh của 1 nhóm đăng ký ăn — port từ store/tuitionFee/helpers/group.js.
 * Nhóm default (all/class/grade/level): suy từ bảng student.
 * Nhóm custom (defaultType null): lấy từ bảng nối meal-group-student.
 */

const filterByDefault = group => {
  switch (group.defaultType) {
    case 'class':
      return { currentClass: group.defaultId }
    case 'grade':
      return { grade: group.defaultId }
    case 'level':
      return { academicLevel: group.defaultId }
    case 'all':
      return {}
    default:
      return null
  }
}

export async function countGroupStudents(group) {
  const filter = filterByDefault(group)
  if (filter) {
    return Student.count({ _start: 0, _limit: -1, ...filter })
  }
  return MealGroupStudent.count({ meal_group: group.id })
}

export async function listGroupStudents(group, { _start, _limit }) {
  const filter = filterByDefault(group)
  if (filter) {
    return Student.search({ _start, _limit, _sort: 'nameToNumber:ASC', ...filter })
  }
  // Nhóm custom: map sang student + giữ id bản ghi nối để xóa.
  const rows = await MealGroupStudent.search({
    meal_group: group.id,
    _start,
    _limit,
    _sort: 'nameToNumber:ASC'
  })
  return rows.map(r => ({ ...r.student, groupStudentId: r.id }))
}
